export default __webpack_public_path__ + "static/media/days_bg.9ba6a678.png";